<template>
    <v-speed-dial v-model="fab" :absolute="absolute" :bottom="!noFixed && !fixedTop" :top="!noFixed && fixedTop"
        :right="!noFixed" :fixed="!noFixed" :direction="effectiveDirection" style="z-index: 6;"
        :class="[{ 'fixed-bottom': fixedBottom && isMobile }, { 'fixed-top': fixedTop }, { 'fab-with-labels': withLabels }, { 'fab-dark': $vuetify.theme.dark }]">
        <template v-slot:activator>
            <v-btn v-model="fab" color="primary" class="black--text" dark fab depressed small>
                <v-icon>
                    {{ fab ? 'mdi-close' : icon }}
                </v-icon>
            </v-btn>
        </template>
        <template v-if="withLabels && isMobile">
            <transition-group tag="div" class="fab-labeled-list" name="slide-x-transition">
                <div class="fab-labeled" v-for="(item, i) in items" :key="i">
                    <span class="fab-label">{{ item.tooltip }}</span>
                    <v-btn fab depressed small outlined :color="actionColor" class="fab-action-btn"
                        @click="$emit(`click:${item.value}`)">
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-btn>
                </div>
            </transition-group>
        </template>
        <template v-else-if="withTooltips || withLabels">
            <transition-group tag="div" class="fab-row" :style="{'flex-direction': (direction === 'top' || direction === 'bottom') ? 'column-reverse' : 'row' }" name="slide-x-transition">
                <button-tooltip fab depressed small outlined :color="actionColor" button-class="fab-action-btn"
                    v-for="(item, i) in items" :key="i" @click="$emit(`click:${item.value}`)" :tooltip="item.tooltip"
                    :left="leftTooltip">
                    <v-icon>{{ item.icon }}</v-icon>
                </button-tooltip>
            </transition-group>

        </template>
        <template v-else>
            <v-btn fab dark depressed small color="black" v-for="(item, i) in items" :key="i"
                @click="$emit(`click:${item.value}`)">
                <v-icon>{{ item.icon }}</v-icon>
            </v-btn>
        </template>
    </v-speed-dial>
</template>

<script>
import ButtonTooltip from './ButtonTooltip.vue'
export default {
    components: { ButtonTooltip },
    name: "FabMenu",
    props: {
        items: {
            type: Array,
            default: () => []
        },
        icon: {
            type: String,
            default: 'mdi-menu'
        },
        fixedBottom: {
            type: Boolean,
            default: false,
        },
        fixedTop: {
            type: Boolean,
            default: false,
        },
        noFixed: {
            type: Boolean,
            default: false
        },
        direction: {
            type: String,
            default: 'top'
        },
        absolute: {
            type: Boolean,
            default: false
        },
        withTooltips: {
            type: Boolean,
            default: false
        },
        withLabels: {
            type: Boolean,
            default: false
        },
        leftTooltip: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            fab: false
        }
    },
    computed: {
        effectiveDirection(vm = this) {
            return vm.fixedTop && vm.direction === 'top' ? 'bottom' : vm.direction
        },
        actionColor(vm = this) {
            return vm.$vuetify.theme.dark ? 'primary' : 'accent'
        }
    },
}
</script>

<style scoped>
.fixed-bottom {
    bottom: calc(12px + 74px + var(--safe-area-inset-bottom, 0px));
}

.fixed-top {
    top: calc(12px + 74px + var(--safe-area-inset-top, 0px));
}

.fab-row {
    display: flex;
    gap: 6px;
}

.fab-with-labels ::v-deep .v-speed-dial__list {
    overflow: visible;
}

.fab-labeled-list {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.fab-labeled {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fab-label {
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    margin-right: 10px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 20px;
    padding: 6px 14px;
    font-size: 13px;
    font-weight: 600;
    color: var(--v-txtPrimary-base);
    white-space: nowrap;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
}

::v-deep .fab-action-btn {
    background-color: rgba(51, 153, 153, 0.12) !important;
    transition: transform 0.15s, box-shadow 0.15s, background-color 0.15s;
}

.fab-dark ::v-deep .fab-action-btn {
    background-color: rgba(204, 255, 51, 0.12) !important;
}

::v-deep .fab-action-btn:hover {
    transform: scale(1.08);
    background-color: rgba(51, 153, 153, 0.2) !important;
    box-shadow: 0 4px 18px rgba(51, 153, 153, 0.35);
}

.fab-dark ::v-deep .fab-action-btn:hover {
    background-color: rgba(204, 255, 51, 0.2) !important;
    box-shadow: 0 4px 18px rgba(204, 255, 51, 0.4);
}
</style>